import axios from 'axios';

export default {
    loadGlobalConfiguration() {
        return axios.get('/colab/epr/cfg/global');
    },

    loadInputLimits() {
        return axios.get('/colab/epr/cfg/inputs');
    },

    inviteParticipants(invitations) {
        return axios.post('/colab/epr/invite/create', invitations);
    },

    revokeInvitation(token) {
        return axios.delete(`/colab/epr/invite/${token}`);
    },

    loadInviteInfo(inviteId) {
        return axios.get('/colab/epr/invite/' + inviteId);
    },

    redeemInvite(invite) {
        return axios.get('/colab/epr/invite/' + invite + '/redeem');
    },

    doFormLogin(credentials) {

        credentials = {
            name: encodeURIComponent(credentials.name),
            pwd: encodeURIComponent(credentials.pwd)
        }

        let token = btoa(JSON.stringify(credentials));

        return axios.get('/colab/epr/login', {
            headers: { "Authorization": 'ENAIO ' + token }
        });
    },

    getAboutInfo() {
        return axios.get('/colab/epr/settings/about');
    },

    deleteRole(roleId) {
        return axios.delete('/colab/epr/roles/role/' + roleId);
    },

    loadRights() {
        return axios.get('/colab/epr/roles/permissions');
    },

    loadRoles() {
        return axios.get('/colab/epr/roles');
    },

    createRole(role) {
        return axios.post('/colab/epr/roles', role);
    },
    markJob() {
        return axios.post('/colab/epr/admin/mark');
    }

};
